export const ProcessSettingVI = {
    "processSetting":"Cài đặt quy trình"
}